import { all } from 'redux-saga/effects';
import {
  watchDeleteProductSaga,
  watchFetchProductsSaga,
  watchFetchSingleProductSaga,
} from './products/saga';
import {
  watchAddAssociationSaga,
  watchDeleteAssociationSaga,
  watchFetchProductGroupsSaga,
  watchFetchSingleProductGroupSaga,
} from './associations/saga';

import {
  watchFetchProductsBySectionSaga,
  watchCalculateProductsQuantitySaga,
  watchFetchColorsSaga,
  watchFetchTypesSaga,
  watchFetchHeightsSaga,
  watchFetchFiltersSaga,
} from './form/saga';
import {
  watchFetchImportFromFileSaga,
} from './importer/saga';
import { watchDeleteContentSaga } from './commons/saga';

export default function* rootSaga() {
  yield all([
    watchFetchFiltersSaga(),
    watchFetchColorsSaga(),
    watchFetchTypesSaga(),
    watchFetchHeightsSaga(),
    watchFetchProductsSaga(),
    watchFetchProductsBySectionSaga(),
    watchFetchProductGroupsSaga(),
    watchFetchSingleProductSaga(),
    watchFetchSingleProductGroupSaga(),
    watchAddAssociationSaga(),
    watchDeleteAssociationSaga(),
    watchCalculateProductsQuantitySaga(),
    watchFetchImportFromFileSaga(),
    watchDeleteProductSaga(),
    watchDeleteContentSaga(),
  ]);
  yield;
}
